import { Pipe, PipeTransform } from '@angular/core';
import { ValidationErrors } from '@angular/forms';

@Pipe({
  standalone: true,
  name: 'formControlKeyError',
})
export class FormControlKeyErrorPipe implements PipeTransform {
  transform(errors: ValidationErrors | null, pathKey: string, showError = false, staticKey = false): string {
    if (errors && showError) {
      if (staticKey) {
        return pathKey;
      }

      const [firstErrorKey] = Object.keys(errors);

      return `${pathKey}.${firstErrorKey}`;
    }

    return '';
  }
}
